export enum StateCategory {
  None = 0,
  Table = 1,
  Map = 2,
  Dashboard = 3
}
